module.exports = __webpack_public_path__ + "static/27-917a7b35f7371c0701d49615b7c92463.png";